import { create } from 'zustand';
import { minigameApi } from '../services/api';
import type { MinigameAccess } from '../types/minigame';

// Whether the minigame feature is visible to the current player, fetched once per session.
// Staff always see it; everyone else only once an admin has published at least one minigame.
// It lives in its own tiny store because the NAVBAR needs it on every page, and re-asking on
// each render would be wasteful.

interface MinigameAccessStore extends MinigameAccess {
  loaded: boolean;
  load: () => Promise<void>;
  /** Re-read after an admin publishes/withdraws something. */
  refresh: () => Promise<void>;
  reset: () => void;
}

const EMPTY: MinigameAccess = { visible: false, staff: false, canPublish: false, publishedCount: 0 };

export const useMinigameAccessStore = create<MinigameAccessStore>((set) => ({
  ...EMPTY,
  loaded: false,

  load: async () => {
    try {
      const res = await minigameApi.access();
      const a = res.data as MinigameAccess;
      set({ ...a, loaded: true });
    } catch {
      // Not signed in, or the endpoint is unreachable — keep the feature hidden.
      set({ ...EMPTY, loaded: true });
    }
  },

  refresh: async () => {
    try {
      const res = await minigameApi.access();
      set({ ...(res.data as MinigameAccess), loaded: true });
    } catch { /* keep whatever we had */ }
  },

  reset: () => set({ ...EMPTY, loaded: false }),
}));
